<template>
  <div class="cd603-chart-wrap">
    <div class="cd603-chart__content scrollbar-none" :class="{ 'is-mobile': isMobile }">
      <el-row v-for="(row, i) in rows" :gutter="30" :key="`row_${i}`">
        <el-col :span="24 / row.length" v-for="col in row" :key="col.sensorSeq">
          <chart
            ref="chart"
            :height="calcHeight(row.length)"
            :data="col"
            :ind="col._ind % 2"
            class="mt-15"
          ></chart>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Chart from './chart.vue';
import resize from '../utils/resize';
import { isMobile } from '@/utils/is';

export default {
  mixins: [resize],
  components: {
    Chart
  },
  props: {
    datas: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    rows() {
      const { datas } = this;
      const colNum = datas.length === 4 ? 2 : 3;
      const rows = [];
      let offset = 0;

      datas.forEach((e, i) => (e._ind = i));

      for (let i = 0, j = Math.ceil(datas.length / colNum); i < j; i++) {
        offset = i * colNum;
        rows.push(datas.slice(offset, offset + colNum));
      }

      return rows;
    },
    isMobile() {
      return isMobile();
    }
  },
  methods: {
    calcHeight() {
      const ol = this.datas.length;
      return (ol > 3 ? 1 : 2) * (this.unit - 22);
    },
    setData(list, data) {
      this.$nextTick(() => {
        let temp = [];
        Array(list[0].sensors.length)
          .fill(0)
          .forEach((_, i) => {
            temp = list.map(e => ({
              beginTime: e.beginTime,
              ...(e.sensors[i] || {})
            }));
            this.$refs.chart[i].setDataList(temp, data.sensors[i]);
          });
      });
    }
  }
};
</script>

<style lang="scss">
.cd603-chart-wrap {
  $height: calc(100% - 100px);
  max-height: $height;
  height: $height;

  width: 100%;
  overflow: hidden;
  .cd603-chart__content {
    height: 100%;
    width: 100%;

    overflow-y: scroll;
    overflow-x: hidden;
    // margin-right: -18px;
    // width: calc(100% + 18px);

    .is-mobile {
      margin-right: 0;
      width: 100%;
    }
  }
}
</style>
